// src/translator.js
console.log('✅ translator.js loaded successfully!');

import { myFetchJsonContent } from './utils-fetch-data-json.js';

/** in‑memory map: language → { key: translation } */
const textTranslations = {};

/** in‑memory map: language → { key: translation } */
const fragmentsTranslations = {};

/** promise map so we only ever fetch once per language */
const loadingPromises = {};

const loadingPromisesFragments = {};

/**
 * Loads and caches translations for a given language, returning a Proxy so
 * that missing keys fall back to the key string itself.
 */
export async function loadTextTranslations(language) {
  // 1) if already loaded, return it
  if (textTranslations[language]) {
    return textTranslations[language];
  }

  // 2) if a load is in flight, await it
  if (loadingPromises[language]) {
    return loadingPromises[language];
  }

  // 3) otherwise start loading
  loadingPromises[language] = (async () => {
    try {
      const path = `data/${language}/all-static-controls-translations.json`;
      const raw = await myFetchJsonContent(path);
      const data = raw && typeof raw === 'object' ? raw : {};
      // wrap in a proxy that returns the key on a miss
      textTranslations[language] = new Proxy(data, {
        get(target, prop) {
          if (typeof prop === 'string') {
            return prop in target ? target[prop] : prop;
          }
          return target[prop];
        },
      });
    } catch (err) {
      console.error(`❌ Error loading translations for ${language}:`, err);
      // fallback: proxy that always returns the key
      textTranslations[language] = new Proxy(
        {},
        {
          get(_, prop) {
            return typeof prop === 'string' ? prop : undefined;
          },
        }
      );
    }
    return textTranslations[language];
  })();

  return loadingPromises[language];
}

/**
 * Shorthand: get a single translation (via the proxy) for key/lang
 */
export async function loadSingleTextTranslations(key, language) {
  const dict = await loadTextTranslations(language);
  return dict[key];
}

export async function loadFragmentsTranslations(language) {
  // 1) if already loaded, return it
  if (fragmentsTranslations[language]) {
    return fragmentsTranslations[language];
  }

  // 2) if a load is in flight, await it
  if (loadingPromisesFragments[language]) {
    return loadingPromisesFragments[language];
  }

  // 3) otherwise start loading
  loadingPromisesFragments[language] = (async () => {
    try {
      const path = `data/${language}/all-static-fragments-translations.json`;
      const raw = await myFetchJsonContent(path);
      const data = raw && typeof raw === 'object' ? raw : {};
      // wrap in a proxy that returns the key on a miss
      fragmentsTranslations[language] = new Proxy(data, {
        get(target, prop) {
          if (typeof prop === 'string') {
            return prop in target ? target[prop] : prop;
          }
          return target[prop];
        },
      });
    } catch (err) {
      console.error(`❌ Error loading fragments translations for ${language}:`, err);
      // fallback: proxy that always returns the key
      fragmentsTranslations[language] = new Proxy(
        {},
        {
          get(_, prop) {
            return typeof prop === 'string' ? prop : undefined;
          },
        }
      );
    }
    return fragmentsTranslations[language];
  })();

  return loadingPromisesFragments[language];
}

//export function loadTextTranslations(language) {
//    // 1) if we already have the data, return it immediately
//    if (textTranslations[language]) {
//        return Promise.resolve(textTranslations[language]);
//    }

//    // 2) if a load is already in flight, return its promise
//    if (loadingPromises[language]) {
//        return loadingPromises[language];
//    }

//    // 3) otherwise kick off the fetch and stash the promise
//    loadingPromises[language] = (async () => {
//        try {
//            const path = `data/${language}/all-static-controls-translations.json`;
//            const data = await myFetchJsonContent(path);
//            if (data && typeof data === "object") {
//                textTranslations[language] = data;
//            } else {
//                console.error("❌ Invalid JSON structure received");
//                textTranslations[language] = {};
//            }
//        } catch (e) {
//            console.error("❌ Error loading text translations:", e);
//            textTranslations[language] = {};
//        }
//        return textTranslations[language];
//    })();

//    return loadingPromises[language];
//}

export async function getTextTranslationByKey(key, language) {
  if (!key) {
    console.warn('⚠️ Text Translation key is empty');
    return key;
  }

  const translations = await loadTextTranslations(language);

  if (translations[key]) {
    return translations[key];
  } else {
    console.warn(`⚠️ Missing translation for “${key}” in ${language}`);
    return key;
  }
}

//console.log("✅ translator.js loaded successfully!");

//import { myFetchJsonContent } from "./utils-fetch-data-json.js";

//const textTranslations = {};

///**
// * Load Text Translations for the current language
// * Uses the language code from appState
// */

//export async function loadTextTranslations(language) {
//    //console.log(`📥 Fetching text translations for language: ${language}`);

//    // Check if translations for the language are already loaded
//    if (!textTranslations[language]) {
//        try {
//            const path = `data/${language}/all-static-controls-translations.json`;
//            const data = await myFetchJsonContent(path);

//            // Validate the data structure
//            if (typeof data !== 'object' || data === null) {
//                console.error("❌ Invalid JSON structure received");
//                textTranslations[language] = {};  // Fallback to an empty object
//            } else {
//                console.log("✅ Text translations parsed successfully.");
//                textTranslations[language] = data;
//            }

//            console.log(`✅ Text translations loaded for ${language}`);
//        } catch (error) {
//            console.error("❌ Error loading text translations:", error.message);
//            textTranslations[language] = {};  // Fallback to an empty object
//        }
//    } else {
//        //  console.log(`✅ Text translations for ${language} already loaded.`);

//    }

//    // Return the cached translations
//    return textTranslations[language];
//}

//export async function getTextTranslationByKey(key, language) {
//    if (!key) {
//        console.warn("⚠️ Text Translation key is empty or undefined");
//        return key; // Return the key itself if it's empty
//    }

//    // Ensure the translations for the specified language are loaded
//    const translations = await loadTextTranslations(language);

//    // Check if translations are loaded correctly
//    if (!translations) {
//        console.error(`❌ Translations for language ${language} not loaded.`);
//        return key; // Fallback to key if translations are not loaded
//    }

//    // Check if the translation exists for the key
//    if (translations[key]) {
//        return translations[key];
//    } else {
//        console.warn(`⚠️ Text Translation missing for key: ${key}`);
//        return key; // Return the key itself if translation is missing
//    }
//}
